/**
 * The function `getContactInfo` makes an asynchronous request to a specified base URL and returns the
 * contact information received from the response.
 * @param {string} baseUrl - The `baseUrl` parameter is a string that represents the base URL of the
 * API endpoint. It is used to construct the complete URL for the `fetch` request.
 * @returns The function `getContactInfo` is returning the data fetched from the `/contact` endpoint of
 * the provided `baseUrl`.
 */
export const getContactInfo = async () => {
  try {
    const response = await fetch(`/Widget/Contact`);
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Hiba az adatok lekérésekor!');
  }
};
